<template>
  <b-modal
    id="create-edit-milestone-modal"
    :title="milestone ? $t('Edit Milestone') : $t('Add Milestone')"
    :ok-title="milestone ? $t('Update') : $t('Add')"
    :ok-disabled="isProcessing"
    :cancel-disabled="isProcessing"
    @ok="handleSubmit"
  >
    <b-overlay :show="isProcessing">
      <validation-observer ref="milestoneForm">
        <validation-provider
          name="milestone name"
          rules="required"
          v-slot="{ errors }"
        >
          <b-form-group :label="$t('Name')">
            <b-form-input
              v-model="form.name"
              :placeholder="$t('Milestone name')"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>

        <b-form-group :label="$t('Description')">
          <b-form-textarea
            v-model="form.description"
            :placeholder="$t('Milestone description')"
            :rows="3"
          />
        </b-form-group>

        <validation-provider
          name="deadline"
          rules="required"
          v-slot="{ errors }"
        >
          <b-form-group :label="$t('Deadline')">
            <b-form-datepicker
              v-model="form.deadline"
              :placeholder="$t('Milestone deadline')"
              :min="TODAY()"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>
      </validation-observer>
    </b-overlay>
  </b-modal>
</template>

<script>
import { BModal, BFormGroup, BFormInput, BFormTextarea, BFormDatepicker, BOverlay } from 'bootstrap-vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { mapActions } from 'vuex';

export default {
  components: {
    BModal,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormDatepicker,
    BOverlay,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    milestone: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      form: {},
      isProcessing: false,
    }
  },
  computed: {
    boardUid() {
      return this.$route.params.boardUid;
    },
    projectUid() {
      return this.$store.state.project.selectedProject;
    },
  },
  watch: {
    milestone: {
      immediate: true,
      handler(val) {
        if (val) {
          const { __typename, ...milestone } = val;
          this.form = { ...milestone }
        } else this.form = {}
      },
    },
  },
  methods: {
    ...mapActions('boards', ['createBoardMilestone', 'updateBoardMilestone']),
    async handleSubmit(bvModal) {
      bvModal.preventDefault();
      this.$refs.milestoneForm.validate().then(async valid => {
        if (valid) {
          this.isProcessing = true
          try {
            let response
            const { uuid, ...input } = this.form;
            if (uuid) {
              response = await this.updateBoardMilestone({
                projectUid: this.projectUid,
                boardUid: this.boardUid,
                uuid,
                input,
              })
              this.$emit('updated')
            } else {
              response = await this.createBoardMilestone({
                projectUid: this.projectUid,
                boardUid: this.boardUid,
                input,
              })
              this.$emit('refresh')
            }
            this.showSuccess(response.message)
            this.$bvModal.hide('create-edit-milestone-modal');
            this.form = {}
          } catch (error) {
            this.showError(error.message)
          } finally {
            this.isProcessing = false
          }
        }
      });
    },
  },
};
</script>